import React from 'react'
import moment from 'moment-timezone'
import { find, isEmpty } from 'lodash'

import Modal from 'Components/Modal'
import StringManipulator from 'Utilities/StringManipulator'

const Event = (props) => {
  const {
    onClose,
    event
  } = props

  const linkableTicket = find(event.meta.linkables, { linkable_type: 'Ticket' })

  return (
    <Modal title={event.title} removeModal={onClose}>
      <div className="dispatcher__event">
        <div className="dispatcher__event__details">
          <ul className="details-list list--no-list-style">
            { !isEmpty(event.meta.notes) && (
              <li className="details-list__info-box">
                <p className="details-list__label">Description</p>
                {StringManipulator.simpleFormat(event.meta.notes)}
              </li>
            )}
            <li>
              <p className="details-list__label">Start</p>
              {moment(event.start).format('MMMM Do YYYY, HH:mm')}
            </li>
            <li>
              <p className="details-list__label">End</p>
              {moment(event.end).format('MMMM Do YYYY, HH:mm')}
            </li>
            <li>
              <p className="details-list__label">Resource</p>
              {event.meta.owner.name}
            </li>
            { !isEmpty(event.meta.location) && (
              <li>
                <p className="details-list__label">Location</p>
                {event.meta.location}
              </li>
            )}
            { linkableTicket && (
              <li>
                <p className="details-list__label">Ticket</p>
                <a href={`/tickets/${linkableTicket.linkable_id}`}>
                  Ticket #
                  {`${linkableTicket.linkable_id}`}
                </a>
              </li>
            )}
            { event.meta.klass_name === 'Task' && (
              <li>
                <p className="details-list__label">Taskable</p>
                <a href={`${event.meta.taskable_link}`}>
                  {`${event.meta.taskable_type} #${event.meta.taskable_id}`}
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>
    </Modal>
  )
}

export default Event
